// 默认注册
if (typeof window !== 'undefined') {
  window['disableFabricLogging'] = false;
}
/**
 * 默认disableDimBridgeLogging不指定, 我们可以在生产环境手动配置`disableDimBridgeLogging=true`
 * @returns
 */
const enabledLogging = (): boolean => {
  return (
    typeof console !== 'undefined' && window['disableFabricLogging'] !== true
  );
};

export const logData = (...args) => {
  if (enabledLogging()) {
    console.log(...args);
  }
};

export const logError = (...args) => {
  if (enabledLogging()) {
    // Maybe Need to report to remote server.
    console.error(...args);
  }
};

export const logWarn = (...args) => {
  if (enabledLogging()) {
    // Maybe Need to report to remote server.
    console.warn(...args);
  }
};
